import Tabs from '../../js/src/tabs.js';

(function ($) {

        $('section.tabs-flexible').each(function(index, tab) {
            new Tabs($(tab), '.tabs-flexible__wrapper .button-group li');
        });

    $('.tabs-flexible .tabs-flexible__search[data-search-type="faq"]').on('submit', (e) => {
        var value = $('.tabs-flexible .tabs-flexible__search input[type="search"]').val();
        e.target.action = `https://future.connect.curtin.edu.au/app/answers/list/kw/${encodeURI(value)}/page/1/session/`;
        return true;
    });

})(jQuery);
